import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MailIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { contact, images, navLinks } from '../data/site';
import { services } from '../data/services';
export function SiteFooter() {
  return <footer className="w-full bg-navy-dark text-white" data-id="element-127" data-mp="3mfgc4umqu393">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-2 lg:grid-cols-4" data-id="element-128" data-mp="3hhet29pbi3xm">
        <div data-id="element-129" data-mp="3dhw515279cqk">
          <Link to="/" className="inline-block bg-white px-5 py-4" aria-label="Guernsey Cleaning — home" data-id="element-130" data-mp="3dhmi5qcgblp3">
            <img src={images.logo} alt="Guernsey Cleaning — Clean Spaces. Better Places." className="h-11 w-auto" data-id="element-131" data-mp="33if0iqyop4w6" />
          </Link>
          <p className="mt-5 text-[15px] leading-relaxed text-white/65" data-id="element-132" data-mp="11rbpw1osnqbm">
            Professional property cleaning services across Guernsey. Clean Spaces.
            Better Places.
          </p>
        </div>

        <nav aria-label="Footer navigation" data-id="element-133" data-mp="15r50iu5uh2o2">
          <h2 className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-134" data-mp="15padnab0j0hc">
            Explore
          </h2>
          <ul className="mt-5 space-y-3 text-[15px] text-white/70" data-id="element-135" data-mp="1anlptros5n2q">
            {navLinks.map(link => <li key={link.href} data-id="element-136" data-mp="10rsgsia9sbpp">
                <Link to={link.href} className="transition-colors hover:text-gold-light" data-id="element-137" data-mp="10stqojfjus5u">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div data-id="element-138" data-mp="1tfejzpfl5ec1">
          <h2 className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-139" data-mp="1tfwnn74kuutz">
            Services
          </h2>
          <ul className="mt-5 space-y-3 text-[15px] text-white/70" data-id="element-140" data-mp="1jqmtllq6b238">
            {services.map(service => <li key={service.slug} data-id="element-141" data-mp="27gh43wn0sekb">
                <Link to={`/services/${service.slug}`} className="transition-colors hover:text-gold-light" data-id="element-142" data-mp="27ffiwzcaibov">
                  {service.title}
                </Link>
              </li>)}
          </ul>
        </div>

        <div data-id="element-143" data-mp="2h3l2piijk9bc">
          <h2 className="font-display text-[12px] font-bold uppercase tracking-[0.28em] text-gold" data-id="element-144" data-mp="2h4w4jcsff6zt">
            Contact
          </h2>
          <ul className="mt-5 space-y-3 text-[15px] text-white/70" data-id="element-145" data-mp="2d4c8ydni4bfs">
            <li data-id="element-146" data-mp="282d7587etmky">
              <a href={contact.phoneHref} className="flex items-center gap-2 transition-colors hover:text-gold-light" data-id="element-147" data-mp="282vcqvfypd5j">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-148" data-mp="1ycaexa844cno" />
                {contact.phone}
              </a>
            </li>
            <li data-id="element-149" data-mp="1teibpk20p446">
              <a href={`mailto:${contact.email}`} className="flex items-center gap-2 transition-colors hover:text-gold-light" data-id="element-150" data-mp="1tbw4jlj1gqmh">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-151" data-mp="1kcsm8jrp4f91" />
                {contact.email}
              </a>
            </li>
            <li className="flex items-center gap-2" data-id="element-152" data-mp="3r1t6r9e91ys8">
              <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-153" data-mp="3r11ea7fy8h66" />
              {contact.hours}
            </li>
            <li className="flex items-center gap-2" data-id="element-154" data-mp="3vz2umklzq2dy">
              <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-155" data-mp="4u35jbkkxfot" />
              {contact.location}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10" data-id="element-156" data-mp="8u3rdha0ct5w">
        <div className="mx-auto max-w-7xl px-6 py-6 text-center text-[13px] text-white/50" data-id="element-157" data-mp="38c4i1y0zrelb">
          © {new Date().getFullYear()} Guernsey Cleaning. All rights reserved.
        </div>
      </div>
    </footer>;
}